module.exports = __webpack_public_path__ + "static/media/mitsubishi-provider.9458c738.svg";